var deps = module.exports = {
  ALL: ['data', 'fields', 'scales', 'signals']
};
deps.ALL.forEach(function(k) { deps[k.toUpperCase()] = k; });



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-dataflow/src/Dependencies.js
// module id = 289
// module chunks = 0